import React, { useRef } from "react";
import { FaCamera } from "react-icons/fa6";
import { Link } from "react-router-dom";
import { useFormContext } from "@/providers";
import { PROFILE_IMAGE_SERVER_URL } from "@/constants";

export const ImageSection = () => {
  const { register, setValue, watch, errors, fieldRefs } = useFormContext();

  const fileInputRef = useRef(null);
  const imageFile = watch("image");

  const handleBrowseClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setValue("image", [file]); // Ensure the value is set as an array
    }
  };

  const handleDeleteImage = () => {
    setValue("image", null);
  };

  return (
    <div className="max-w-4xl p-6 mx-auto bg-white rounded-lg shadow-md">
      <div className="mb-6">
        <h3 className="text-lg font-semibold">Photo</h3>
        <Link
          to={`/user-profile?name=${
            JSON.parse(localStorage.getItem("data"))?.display_name
          }`}
          state={{
            host_id: JSON.parse(localStorage.getItem("data"))?.id,
            email: JSON.parse(localStorage.getItem("data"))?.email,
          }}
        >
          <h3 className="text-blue-500 view_profile">View Profile</h3>
        </Link>
      </div>

      <div className="gap-4 ">
        <div className="relative profile-pic">
          <label
            className="flex flex-col text-center -label"
            htmlFor="file"
            ref={(el) => (fieldRefs.current["image"] = el)}
          >
            {!imageFile && (
              <>
                <FaCamera className="text-white profile_btn_inner" />
                <span className="text-center text-white profile_btn_inner">
                  Change Image
                </span>
              </>
            )}
          </label>

          <input
            id="file"
            type="file"
            {...register("image")}
            ref={fileInputRef}
            className="hidden"
            onChange={handleFileChange}
            accept=".jpeg, .jpg, .png, .webp"
          />

          {imageFile && imageFile[0] && (
            <img
              src={
                typeof imageFile[0] !== "string"
                  ? URL.createObjectURL(imageFile[0])
                  : `${PROFILE_IMAGE_SERVER_URL}/${watch("image")}`
              }
              alt="Profile"
              className="object-cover w-48 h-48 rounded-md"
            />
          )}
        </div>

        <div className="flex flex-col">
          <p className="text-sm text-gray-600">
            Allowed *.jpeg, *.jpg, *.png, *.webp
          </p>

          <div className="flex justify-between gap-4 mt-4">
            <button
              type="button"
              className="border border-gray-700 font-medium bg-[#8ec639] rounded-md text-white px-8 py-3"
              onClick={handleBrowseClick}
            >
              Browse
            </button>
            <button
              type="button"
              className="px-8 py-3 font-medium text-white bg-gray-800 border border-gray-700 rounded-md"
              onClick={handleDeleteImage}
            >
              Delete
            </button>
          </div>

          {errors.image && (
            <span className="text-xs text-red-500">{errors.image.message}</span>
          )}
        </div>
      </div>
    </div>
  );
};
